/** Player inbox + navbar badge while on /messages — keep in sync */
export const PLAYER_MESSAGES_POLL_MS = 4000;

/** Admin feedback list */
export const ADMIN_MESSAGES_POLL_MS = 20000;
